import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { IndividualSocialTypeReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class IndividualSocialTypeReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/individualSocialTypeReferences';
    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getIndividualSocialTypeReferences(): Observable<IndividualSocialTypeReferenceModel[]> {
        return this.httpGet<IndividualSocialTypeReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}